import { render, staticRenderFns } from "./KlikkitLogoLoader.vue?vue&type=template&id=ea54e158&"
import script from "./KlikkitLogoLoader.vue?vue&type=script&lang=js&"
export * from "./KlikkitLogoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports